/**
 * This is here only because of wlc tv, purge purge purge
 */
jQuery(function ($) {
  // We will retrieve the data attributes from the default article list
  var $articleList = $('div.article-list.default');

  function loadPosts(postIds, $btn, action, success) {
    $('button[data-ajaxpost] i').removeClass('hidden');
    $.ajax({
      method: 'POST',
      url: $btn.data('url'),
      data: {
        action: action,
        postIds: postIds,
        category: $articleList.data('categoryid') || 0, // Pass category id if on a category page
        author: $articleList.data('authorid') || 0, // Pass author id if on an author page
        search: $articleList.data('search') || 0, // Pass search query if searching
      },
      success: success,
      complete: function (xhr) {
        $(document).trigger('ajaxPostsLoaded');
        if (typeof $btn !== 'undefined') {
          $btn.prop('disabled', false);
          $('.more-available', $btn).removeClass('loading');
        }
        if (xhr.status !== 200 || xhr.responseText === '') {
          $articleList.addClass('all-posts-loaded');
          $btn
            .prop('disabled', 'disabled')
            .find('span.more-available')
            .hide()
            .next('span.all-loaded')
            .removeClass('hidden');
        }
      },
    });
  }

  $('button[data-ajaxpost]').on('click', function (e) {
    var $btn = $(this);
    var action = $(this).closest('.article-list-more').data('action');
    if (typeof action === 'undefined') {
      action = 'load_posts';
    }
    $btn.prop('disabled', 'disabled');
    $('.more-available', $btn).addClass('loading');
    // Grab articles from all article lists on the page, so we do not
    // return duplicate posts
    var postIds = $('.promo, .main-promo, .article-list')
      .find('article')
      .map(function () {
        return $(this).data('postid');
      })
      .get();
    loadPosts(postIds, $btn, action, function (msg) {
      $btn.find('i').addClass('hidden');
      $articleList.append(msg);
    });
  });
});
